import { useState } from "react";
import { waLink, WHATSAPP_INTENTS } from "../config";

const REGION_FORM_URL = "https://readdy.ai/api/form/d9vi7heth95mubjtu8dg";

type Result = "idle" | "available" | "unavailable";

export default function RegionCheck() {
  const [query, setQuery] = useState("");
  const [result, setResult] = useState<Result>("idle");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const check = () => {
    if (!query.trim()) return;
    // Demo kontrol: gerçek bölge verisi backend bağlanınca gelecek
    setResult("available");
  };

  const handleWaitlist = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = ((fd.get("phone_alt") as string) ?? "").trim();
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }
    fd.delete("phone_alt");
    const body = new URLSearchParams(fd as never).toString();
    try {
      const res = await fetch(REGION_FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body,
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || responseText;
      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(serverMsg || "Bir şeyler ters gitti. Lütfen tekrar deneyin.");
      }
    } catch {
      setStatus("error");
      setFormError("Ağ hatası. Lütfen tekrar deneyin.");
    }
  };

  return (
    <section id="bolge" className="bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-xs font-bold tracking-[0.25em] text-primary-600 uppercase">
            Teslimat
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            BÖLGENE GELİYOR MUYUZ?
          </h2>
        </div>

        <div className="mt-8">
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="İlçe veya mahalle yaz"
              className="flex-1 px-5 py-3.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
            />
            <button
              onClick={check}
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              BÖLGEMİ KONTROL ET
            </button>
          </div>

          {result === "available" && (
            <div className="mt-5 bg-accent-50 border border-accent-200 rounded-lg p-6 text-center animate-fade-up">
              <div className="w-12 h-12 mx-auto rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 flex items-center justify-center">
                <i className="ri-check-line text-2xl"></i>
              </div>
              <p className="mt-3 font-heading text-xl font-bold text-foreground-950">
                Harika! Bölgenize teslimatımız mevcut.
              </p>
              <a
                href="#menu"
                className="mt-4 inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                MENÜMÜ OLUŞTUR
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          )}

          {result === "unavailable" && (
            <div className="mt-5 bg-background-100 border border-background-200 rounded-lg p-6 animate-fade-up">
              <p className="font-heading text-xl font-bold text-foreground-950">
                Henüz bu bölgeye teslimatımız bulunmuyor.
              </p>
              <p className="mt-2 text-sm text-foreground-600">
                Açılış listesine katılabilirsiniz.
              </p>

              <form
                data-readdy-form
                onSubmit={handleWaitlist}
                className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3"
              >
                <input
                  type="text"
                  name="name"
                  placeholder="Adınız"
                  required
                  className="px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Telefon numaranız"
                  required
                  className="px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
                />
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="lead-hp"
                />
                <div className="sm:col-span-2 flex flex-col sm:flex-row gap-3">
                  <button
                    type="submit"
                    className="flex-1 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    AÇILIŞ LİSTESİNE KATIL
                  </button>
                  <a
                    href={waLink(WHATSAPP_INTENTS.region)}
                    target="_blank"
                    rel="nofollow noopener"
                    className="flex-1 inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border-2 border-accent-500 text-accent-900 text-base font-bold hover:bg-accent-100 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line text-xl"></i>
                    WHATSAPP'TAN SOR
                  </a>
                </div>
                {status === "success" && (
                  <p className="sm:col-span-2 text-sm font-semibold text-primary-600">
                    Teşekkürler! Açılış listesine eklendiniz.
                  </p>
                )}
                {status === "error" && (
                  <p className="sm:col-span-2 text-sm font-semibold text-primary-700">
                    {formError}
                  </p>
                )}
              </form>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}